var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{on:{"click":_vm.logout}},[_c('v-list-item-icon',{staticClass:"mr-3"},[_c('v-icon',[_vm._v("$logout")])],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("logOut")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }